import { render, staticRenderFns } from "./LabInvoiceTable.vue?vue&type=template&id=301e3667&scoped=true&"
import script from "./LabInvoiceTable.vue?vue&type=script&lang=js&"
export * from "./LabInvoiceTable.vue?vue&type=script&lang=js&"
import style0 from "./LabInvoiceTable.vue?vue&type=style&index=0&id=301e3667&lang=scss&scoped=true&"
import style1 from "./LabInvoiceTable.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "301e3667",
  null
  
)

export default component.exports